module.exports = __webpack_public_path__ + "img/logo_navbar.d84bf72e.png";